import React from 'react';
import { AlertTriangleIcon, LockIcon, ZapIcon, TargetIcon, DropletIcon, FlameIcon, BatteryIcon, ChevronRightIcon, CameraIcon, StarIcon } from 'lucide-react';
export function RecommendationsPage() {
  return <div className="min-h-screen bg-[#0d0d0d] text-white font-sans selection:bg-[#b91c1c] selection:text-white" data-id="element-1380">
      {/* Top Nav Bar (matching other pages) */}
      <header className="bg-[#002868] text-white w-full" data-id="element-1381">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-12 flex items-center justify-between" data-id="element-1382">
          <div className="flex items-center gap-2 font-bold text-lg tracking-tight" data-id="element-1383">
            <StarIcon className="w-5 h-5 fill-current text-[#b91c1c]" data-id="element-1384" />
            <span data-id="element-1385">PatriotsInformer</span>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-8 px-4 text-center bg-[#0a0a0a] overflow-hidden" data-id="element-1386">
        {/* Subtle vertical stripes background effect */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(255,255,255,0.1) 40px, rgba(255,255,255,0.1) 80px)'
      }} data-id="element-1387"></div>

        <div className="relative z-10 max-w-3xl mx-auto space-y-6" data-id="element-1388">
          <p className="text-[#c5a059] text-xs font-bold tracking-[0.2em] uppercase" data-id="element-1389">
            Patriots Informer · Trusted Resources
          </p>
          <h1 className="text-4xl md:text-7xl font-black tracking-tighter uppercase text-white leading-none" data-id="element-1390">
            Jack's Picks
          </h1>
          <p className="text-gray-400 text-lg md:text-xl italic font-serif max-w-2xl mx-auto leading-relaxed" data-id="element-1391">
            Every resource here has been hand-selected because it gives real,
            actionable knowledge, not theory. These are the tools I'd want my
            family to have before the lights go out.
          </p>
        </div>
      </section>

      {/* Red Banner */}
      <div className="bg-[#d92b2b] text-white py-3 px-4 text-center" data-id="element-1392">
        <p className="text-sm md:text-base font-bold tracking-wider uppercase flex items-center justify-center gap-2" data-id="element-1393">
          <AlertTriangleIcon className="w-4 h-4 flex-shrink-0" data-id="element-1394" />
          Real preparedness covers three things: Water, Food, and Energy. I've
          got you covered on all three.
        </p>
      </div>

      {/* Trust Badges */}

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-8 space-y-12" data-id="element-1395">
        {/* Section Header */}
        <div className="space-y-2" data-id="element-1396">
          <p className="text-[#c5a059] text-xs font-bold tracking-[0.2em] uppercase" data-id="element-1397">
            My Recommendations
          </p>

          <div className="w-16 h-1 bg-[#c5a059]" data-id="element-1398"></div>
        </div>

        {/* Cards Container */}
        <div className="space-y-8" data-id="element-1399">
          {/* Card 1: Smart Water Box (Full Width) */}
          <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-1400">
            {/* Left Border Accent */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#c5a059]" data-id="element-1401"></div>

            {/* Title Area - Above Image */}
            <div className="p-6 md:p-8 pb-4 md:pb-4 relative" data-id="element-1402">
              {/* Badge */}
              <div className="absolute top-0 right-0 bg-[#d92b2b] text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1" data-id="element-1403">
                Editor's Pick
              </div>
              <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase mb-2" data-id="element-1404">
                <DropletIcon className="w-3 h-3 fill-current text-[#3b82f6]" data-id="element-1405" />
                <span data-id="element-1406">Water Survival</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-black tracking-tight uppercase" data-id="element-1407">
                Smart Water Box
              </h3>
            </div>

            {/* Image + Content Row */}
            <div className="flex flex-col md:flex-row" data-id="element-1408">
              {/* Image Area */}
              <div className="w-full md:w-2/5 bg-[#111827] min-h-[250px] flex items-center justify-center border-y md:border-y-0 md:border-r border-[#333]" data-id="element-1409">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1410">
                  <CameraIcon className="w-6 h-6" data-id="element-1411" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-1412">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col justify-between relative" data-id="element-1413">
                <div className="space-y-4" data-id="element-1414">
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1415">
                    When the tap runs dry — whether from a grid failure, natural
                    disaster, or supply disruption — most families have no plan.
                    The Smart Water Box gives you a real one. A compact, proven
                    system to collect, filter, and store clean drinking water on
                    demand, anywhere.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-1416">
                    <li className="flex items-start gap-2" data-id="element-1417">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1418">
                        ▶
                      </span>
                      <span data-id="element-1419">Works without running water or electricity</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1420">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1421">
                        ▶
                      </span>
                      <span data-id="element-1422">Enough clean water for a family of 4</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1423">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1424">
                        ▶
                      </span>
                      <span data-id="element-1425">Easy to build with common materials</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1426">
                  <div data-id="element-1427">
                    <div className="text-xl font-bold" data-id="element-1428">Watch Free Video</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1429">
                      Limited Availability
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1430">
                    Watch Now <ChevronRightIcon className="w-4 h-4" data-id="element-1431" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1432">
            {/* Card 2: The Lost Superfoods */}
            <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-1433">
              {/* Top Border Accent */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-[#c5a059]" data-id="element-1434"></div>

              {/* Image Area */}
              <div className="w-full bg-[#1c1a11] aspect-[4/3] flex items-center justify-center border-b border-[#333]" data-id="element-1435">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1436">
                  <CameraIcon className="w-6 h-6" data-id="element-1437" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-1438">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6 md:p-8 flex flex-col flex-1 justify-between" data-id="element-1439">
                <div className="space-y-4" data-id="element-1440">
                  <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1441">
                    <FlameIcon className="w-3 h-3 fill-current text-[#f97316]" data-id="element-1442" />
                    <span data-id="element-1443">Food Storage</span>
                  </div>

                  <h3 className="text-2xl font-black tracking-tight uppercase" data-id="element-1444">
                    The Lost Superfoods
                  </h3>

                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1445">
                    126 forgotten foods your grandparents knew how to preserve —
                    without refrigeration, without electricity, and for years at
                    a time. From the US Army's Cold War ration to Viking-era
                    preservation secrets, this is the food knowledge the modern
                    world buried.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-1446">
                    <li className="flex items-start gap-2" data-id="element-1447">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1448">
                        ▶
                      </span>
                      <span data-id="element-1449">Store food for years without a fridge</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1450">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1451">
                        ▶
                      </span>
                      <span data-id="element-1452">Build a full stockpile for under $5/week</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1453">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1454">
                        ▶
                      </span>
                      <span data-id="element-1455">Color photos, step-by-step instructions</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1456">
                  <div data-id="element-1457">
                    <div className="text-xl font-bold" data-id="element-1458">$37</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1459">
                      Physical + Digital Book
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1460">
                    Get The Book <ChevronRightIcon className="w-4 h-4" data-id="element-1461" />
                  </button>
                </div>
              </div>
            </div>

            {/* Card 3: Solar Innovator System */}
            <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-1462">
              {/* Top Border Accent */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-[#c5a059]" data-id="element-1463"></div>

              {/* Image Area */}
              <div className="w-full bg-[#1a1c11] aspect-[4/3] flex items-center justify-center border-b border-[#333]" data-id="element-1464">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1465">
                  <CameraIcon className="w-6 h-6" data-id="element-1466" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-1467">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6 md:p-8 flex flex-col flex-1 justify-between" data-id="element-1468">
                <div className="space-y-4" data-id="element-1469">
                  <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1470">
                    <ZapIcon className="w-3 h-3 fill-current text-[#eab308]" data-id="element-1471" />
                    <span data-id="element-1472">Energy Independence</span>
                  </div>

                  <h3 className="text-2xl font-black tracking-tight uppercase" data-id="element-1473">
                    Solar Innovator System
                  </h3>

                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1474">
                    A 3D solar sphere inspired by the compound eye of a housefly
                    — built in under 3 hours for around $200. It captures light
                    from nearly every angle, generating up to twice the power of
                    a flat panel in a fraction of the space. No roof required.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-1475">
                    <li className="flex items-start gap-2" data-id="element-1476">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1477">
                        ▶
                      </span>
                      <span data-id="element-1478">Cut your electric bill by 50-80%</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1479">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1480">
                        ▶
                      </span>
                      <span data-id="element-1481">Works on a balcony or terrace — 12 sq ft</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1482">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1483">
                        ▶
                      </span>
                      <span data-id="element-1484">No technical skills required</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1485">
                  <div data-id="element-1486">
                    <div className="text-xl font-bold" data-id="element-1487">$39</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1488">
                      Instant Digital Access
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1489">
                    Watch Now <ChevronRightIcon className="w-4 h-4" data-id="element-1490" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Card 4: The Energy Revolution System (Full Width) */}
          <div className="bg-[#1a1a1a] border border-[#333] flex flex-col md:flex-row relative group" data-id="element-1491">
            {/* Left Border Accent */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#c5a059]" data-id="element-1492"></div>

            {/* Image Area */}
            <div className="w-full md:w-2/5 bg-[#1a1811] min-h-[250px] flex items-center justify-center border-b md:border-b-0 md:border-r border-[#333]" data-id="element-1493">
              <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1494">
                <CameraIcon className="w-6 h-6" data-id="element-1495" />
                <span className="text-xs font-bold tracking-widest" data-id="element-1496">
                  IMAGE HERE
                </span>
              </div>
            </div>

            {/* Content Area */}
            <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col justify-between relative" data-id="element-1497">
              {/* Badge */}
              <div className="absolute top-0 right-0 bg-[#333] text-gray-300 text-[10px] font-bold tracking-widest uppercase px-3 py-1" data-id="element-1498">
                Also Recommended
              </div>

              <div className="space-y-4" data-id="element-1499">
                <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1500">
                  <BatteryIcon className="w-3 h-3 fill-current text-[#c5a059]" data-id="element-1501" />
                  <span data-id="element-1502">Off-Grid Energy</span>
                </div>

                <h3 className="text-2xl md:text-3xl font-black tracking-tight uppercase" data-id="element-1503">
                  The Energy Revolution System
                </h3>

                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1504">
                  A century-old device — suppressed for decades — that
                  multiplies any electricity source up to 7 times over. The
                  energy industry tried to bury it. Now it's out in the open,
                  and it could slash your bill by 88% within 30 days.
                </p>

                <ul className="space-y-2 text-sm text-gray-300" data-id="element-1505">
                  <li className="flex items-start gap-2" data-id="element-1506">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1507">▶</span>
                    <span data-id="element-1508">Based on 100-year-old suppressed technology</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1509">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1510">▶</span>
                    <span data-id="element-1511">Multiplies any power source up to 7x</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1512">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1513">▶</span>
                    <span data-id="element-1514">Runs indefinitely — no fuel, no intervention</span>
                  </li>
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1515">
                <div data-id="element-1516">
                  <div className="text-xl font-bold" data-id="element-1517">Under $98</div>
                  <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1518">
                    One-Time Payment · 60-Day Guarantee
                  </div>
                </div>
                <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1519">
                  Watch The Leaked Video{' '}
                  <ChevronRightIcon className="w-4 h-4" data-id="element-1520" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#222] py-12 px-4 text-center text-xs text-gray-500 space-y-2" data-id="element-1521">
        <p data-id="element-1522">
          © 2026 Patriots Informer ·{' '}
          <a href="#" className="text-[#c5a059] hover:underline" data-id="element-1523">
            patriotsinformer.com
          </a>
        </p>
        <p className="max-w-2xl mx-auto" data-id="element-1524">
          This page contains affiliate links. If you purchase through these
          links, Patriots Informer may earn a commission at no extra cost to
          you. All products are independently selected and personally
          recommended.
        </p>
      </footer>
    </div>;
}